import { render, staticRenderFns } from "./txt-tag.vue?vue&type=template&id=6f3d8627&scoped=true"
import script from "./txt-tag.vue?vue&type=script&lang=js"
export * from "./txt-tag.vue?vue&type=script&lang=js"
import style0 from "./txt-tag.vue?vue&type=style&index=0&id=6f3d8627&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3d8627",
  null
  
)

export default component.exports